module.exports = __webpack_public_path__ + "img/coricidin_hbp_cold_flu_relief_tablets_high_blood_pressure.ec2b86f2.png";